import { render } from "./goods_cart.vue?vue&type=template&id=770dc132&scoped=true"
import script from "./goods_cart.vue?vue&type=script&lang=js"
export * from "./goods_cart.vue?vue&type=script&lang=js"

import "./goods_cart.vue?vue&type=style&index=0&id=770dc132&lang=less&scoped=true"

import exportComponent from "E:\\project\\hkpay\\shop_html\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-770dc132"]])

export default __exports__